import React, { Component } from 'react';
import {
    MDBContainer,
    MDBModal,
    MDBModalBody,
    MDBModalHeader,
    MDBDataTableV5
} from 'mdbreact';
import moment from 'moment';

class FullScreenTable extends Component {
    state = {
        modal: true,
        dataTable: {}
    }

    componentDidMount = async() => {
        var columns = []
        var rows = []
        const serviceData =  await this.props.dataTable()
        for (let key of Object.keys(serviceData[0])) {
            if (key === 'GlobalID') {
                columns.push({
                    label: key,
                    field: key,
                    width: 300
                })
            } else {
                columns.push({
                    label: key,
                    field: key,
                    width: 200
                })
            }

        }
        for(let data of serviceData){
            var dataTemp = data
            for (let keyData of Object.keys(serviceData[0])) {
                if (typeof data[keyData] === 'string' && moment(data[keyData]).isValid()) {
                    dataTemp = {
                        ...dataTemp,
                        [keyData]: moment(data[keyData]).format('MM/DD/YYYY')
                    }
                }
            }
            rows.push(dataTemp)
        }
        
        this.setState({
            dataTable: {
                columns,
                rows
            }
        })
    }

    render() {
        return (
            <MDBContainer>
                <MDBModal isOpen={this.state.modal} toggle={() => this.props.ShowFullscreen()} size="fluid">
                    <MDBModalHeader toggle={() => this.props.ShowFullscreen()}>Data Table</MDBModalHeader>
                    <MDBModalBody>
                        {this.state.dataTable.columns &&
                            <MDBDataTableV5
                                hover
                                className='modalDataTableCSS'
                                responsiveSm={true}
                                scrollX
                                entriesOptions={[5, 20, 25]}
                                entries={5}
                                pagesAmount={4}
                                data={this.state.dataTable}
                                fullPagination
                                searchTop
                                searchBottom={false}
                            />}
                    </MDBModalBody>
                </MDBModal>
            </MDBContainer>
        );
    }
}

export default FullScreenTable;


// WEBPACK FOOTER //
// ./src/components/modals/fullscreenTable.js